import { Jobs, JobsWithSkillsGroup } from "@/interfaces/data_objects/jobs";
import { SearchJobObject } from "@/interfaces/shared/jobs/auto_complete_job_search";
import {
  ACTIVE_ASSESSMENT,
  ALL_CANDIDATES,
  APPLICANT_ASSESSMENTS,
  APPLICANT_ASSESSMENT_DETAILS,
  APP_AI_ASSESSMENT_LISTING,
  APP_ANNOTATION_ASSESSMENT_LISTING,
  APP_ENG_ASSESSMENT_LISTING,
  ASSESSMENT_LISTING,
  ASSESSMENT_LISTING_DATES_FILTER,
  CANDIDATE_VIEW_PAYLOAD,
  DASHBOARD_COUNTS,
  EDITED_STANDARDISED_JOB,
  FETCH_AI_ASSESSMENT_LISTING,
  FETCH_ASSESSMENT_STATS,
  FETCH_AVAILABLE_APPLICANTS,
  FETCH_CANCELLED_ASSESSMENTS_CANDIDATES,
  FETCH_MATCHING_CANDIDATES,
  FETCH_OVERALL_ASSESSMENTS,
  FETCH_REDO_ASSESSMENTS_CANDIDATES,
  GET_EMAIL_TEMPLATES,
  GET_INTERVIEW_LISTING_OBJECT,
  GET_SURVEY_QUESTIONS,
  HOLD_STANDARDISED_JOB,
  INCEPTION_STATS,
  INTERVIEW_LISTING,
  INTERVIEW_OBJECT,
  INTERVIEW_SEARCHED_JOB,
  JOBS_POSTED_BY_RECRUITER,
  JOBS_POSTED_BY_RECRUITER_LOADING,
  JOB_LISTING_DATE_FILTER,
  JOB_LISTING_SEARCHED_JOB_FILTER,
  POKE_CANDIDATE_LOADING,
  POST_JOB_LIMIT_ERROR,
  RECOMMEND_JOB_PROFILES,
  RECRUITER_INTERVIEW_SEARCH_JOB_LOADING,
  RECRUITER_LOADING,
  SELECTED_APPLICANT,
  SELECTED_APPLICANTS,
  SELECTED_CANDIDATE_INTERVIEW_REPORT,
  TOP_JOBS_WITH_CANDIDATES,
  VIEW_CANDIDATES_DYNAMICALLY,
  VIEW_CANDIDATES_PAGINATION
} from "@/store/modules/recruiter/constants";
import {
  ActiveAssessment,
  AllCandidates,
  AppAiAssessmentListing,
  AppAnnotationAssessmentListing,
  AppEngAssessmentListing,
  AppOverAllAssessmentListing,
  ApplicantAssessment,
  ApplicantAssessmentDetailsResponse,
  AssessmentAiListing,
  AssessmentListing,
  AssessmentStats,
  AvailableApplicant,
  CancelledAssessmentCandidates,
  CandidateViewPayload,
  DashboardCounts,
  EmailTemplates,
  InceptionStats,
  InterviewListingCandidates,
  InterviewListingResult,
  Interviews,
  JobsWithCandidates,
  RecruiterState,
  RedoAssessmentCandidates,
  SearchAutocompleteJobPayload,
  SurveyQuestions,
  ViewCandidatesDynamically,
  ViewCandidatesPagination
} from "@/store/modules/recruiter/interfaces";
import { FETCH_APP_AI_ASSESSMENT } from "@/store/urls/recruiter";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";

export default {
  [DASHBOARD_COUNTS]: (state: RecruiterState): DashboardCounts =>
    state.dashboard_counts,
  [FETCH_ASSESSMENT_STATS]: (state: RecruiterState): AssessmentStats | null =>
    state.assessment_stats,
  [RECRUITER_LOADING]: (state: RecruiterState): boolean => state.loading,
  [JOBS_POSTED_BY_RECRUITER_LOADING]: (state: RecruiterState): boolean =>
    state.jobs_posted_loading,
  [JOBS_POSTED_BY_RECRUITER]: (
    state: RecruiterState
  ): { total: number; results: JobsWithCandidates[] } => state.jobs_posted,
  [TOP_JOBS_WITH_CANDIDATES]: (
    state: RecruiterState
  ): { total: number; results: JobsWithCandidates[] } => state.top_jobs_posted,
  [VIEW_CANDIDATES_DYNAMICALLY]: (
    state: RecruiterState
  ): ViewCandidatesDynamically => state.view_candidates_dynamically,
  [FETCH_MATCHING_CANDIDATES]:
    (state: RecruiterState) =>
    (job_id: number, top_jobs: false): JobsWithCandidates | undefined => {
      if (top_jobs)
        return state.top_jobs_posted.results.find(
          (v: Jobs) => v.jid === job_id
        );
      else return state.jobs_posted.results.find((v: Jobs) => v.jid === job_id);
    },
  [RECOMMEND_JOB_PROFILES]: (state: RecruiterState): Jobs[] =>
    state.recommend_job_profiles,
  [CANDIDATE_VIEW_PAYLOAD]: (
    state: RecruiterState
  ): CandidateViewPayload | null => state.candidate_view_payload,
  [ALL_CANDIDATES]: (state: RecruiterState): AllCandidates =>
    state.all_candidates,
  /**
   * Returning poke candidate loading
   * @return boolean
   */
  [POKE_CANDIDATE_LOADING]: (state: RecruiterState): boolean =>
    state.poke_candidate_loading,
  [POST_JOB_LIMIT_ERROR]: (state: RecruiterState): string =>
    state.post_job_limit_error,
  [HOLD_STANDARDISED_JOB]: (
    state: RecruiterState
  ): JobsWithSkillsGroup | null => state.add_standardised_job,
  /**
   * Return searched job for fetching all interviewers of specific job
   * @param state
   */
  [INTERVIEW_SEARCHED_JOB]: (state: RecruiterState): SearchJobObject | null =>
    state.interviews.searched_job,
  [INTERVIEW_LISTING]: (
    state: RecruiterState
  ): Map<number, InterviewListingResult> | null =>
    state.interviews.interview_listing,
  [RECRUITER_INTERVIEW_SEARCH_JOB_LOADING]: (state: RecruiterState): boolean =>
    state.interviews.search_job_loading,
  [VIEW_CANDIDATES_PAGINATION]: (
    state: RecruiterState
  ): ViewCandidatesPagination => state.view_candidates_pagination,
  [INTERVIEW_OBJECT]: (state: RecruiterState): Interviews => state.interviews,
  [EDITED_STANDARDISED_JOB]: (state: RecruiterState): boolean =>
    state.edited_Standardised_job,
  [ASSESSMENT_LISTING]: (state: RecruiterState): AssessmentListing =>
    state.assessment_listing,
  [ASSESSMENT_LISTING_DATES_FILTER]: (state: RecruiterState): string[] =>
    state.assessment_listing.selected_dates,
  [SELECTED_CANDIDATE_INTERVIEW_REPORT]: (
    state: RecruiterState
  ): InterviewListingCandidates[] => state.interviews.selected_candidate,
  [JOB_LISTING_DATE_FILTER]: (state: RecruiterState): string[] =>
    state.jobs_posted.date_filter,
  [JOB_LISTING_SEARCHED_JOB_FILTER]: (
    state: RecruiterState
  ): SearchAutocompleteJobPayload | null =>
    state.jobs_posted.searched_job_title,
  [GET_INTERVIEW_LISTING_OBJECT]:
    (state: RecruiterState) =>
    (job_id: number): InterviewListingResult | undefined => {
      return state.interviews.interview_listing.get(job_id);
    },
  // English Assessment listing
  [APP_ENG_ASSESSMENT_LISTING]:
    (state: RecruiterState) =>
    (version: string): AppEngAssessmentListing => {
      if (version === "v1") return state.eng_assessment_listing;
      else if (version === "v3") return state.eng_assessment_listing_v3;
      else if (version === "v4") return state.eng_assessment_listing_v4;
      else return state.eng_assessment_listing_v2;
    },
  // Annotation Assessment listing
  [APP_ANNOTATION_ASSESSMENT_LISTING]:
    (state: RecruiterState) =>
    (version: string): AppAnnotationAssessmentListing => {
      if (version === "v1") return state.annotation_assessment_listing;
      else if (version === "v3") return state.annotation_assessment_listing_v3;
      else return state.annotation_assessment_listing_v2;
    },
  [APP_AI_ASSESSMENT_LISTING]:
    (state: RecruiterState) => (): AppAiAssessmentListing => {
      return state.app_ai_assessment_listing;
    },
  [FETCH_APP_AI_ASSESSMENT]: (
    state: RecruiterState
  ): AppAssessments.AiAssessmentResults | null => {
    return state.fetch_app_ai_assessment;
  },
  [ACTIVE_ASSESSMENT]: (state: RecruiterState): ActiveAssessment =>
    state.active_assessment,
  [INCEPTION_STATS]: (state: RecruiterState): InceptionStats =>
    state.inseption_stats,
  [FETCH_OVERALL_ASSESSMENTS]: (
    state: RecruiterState
  ): AppOverAllAssessmentListing => state.overall_assessment_listing,
  [FETCH_CANCELLED_ASSESSMENTS_CANDIDATES]: (
    state: RecruiterState
  ): CancelledAssessmentCandidates => state.cancelled_assessment_candidates,
  [FETCH_REDO_ASSESSMENTS_CANDIDATES]: (
    state: RecruiterState
  ): RedoAssessmentCandidates => {
    // console.log(
    //   "state.redo_assessment_candidates",
    //   state.redo_assessment_candidates
    // );
    return state.redo_assessment_candidates;
  },
  [GET_EMAIL_TEMPLATES]: (state: RecruiterState): EmailTemplates[] =>
    state.email_templates,

  [GET_SURVEY_QUESTIONS]: (state: RecruiterState): SurveyQuestions[] =>
    state.survey_questions,

  [FETCH_AI_ASSESSMENT_LISTING]: (
    state: RecruiterState
  ): AssessmentAiListing[] => state.ai_assessment_listing,

  // AI Session getters
  getAiSessionId: (state: RecruiterState): string | null =>
    state.ai_session.session_id,
  getAiSessionMessage: (state: RecruiterState): string =>
    state.ai_session.session_message,
  getChatMessages: (
    state: RecruiterState
  ): Array<{
    type: "user" | "ai";
    text: string;
    time: string;
    loading?: boolean;
  }> => state.ai_session.chat_messages,
  [FETCH_AVAILABLE_APPLICANTS]: (state: RecruiterState): AvailableApplicant[] =>
    state.available_applicants.map((applicant) => ({
      ...applicant,
      value: applicant.value.toString(),
      label: applicant.label
    })),
  [SELECTED_APPLICANT]: (state: RecruiterState): AvailableApplicant | null =>
    state.selected_applicant,
  [SELECTED_APPLICANTS]: (state: RecruiterState): AvailableApplicant[] =>
    state.selected_applicants || [],
  [APPLICANT_ASSESSMENTS]: (state: RecruiterState): ApplicantAssessment[] =>
    state.applicant_assessments || [],
  [APPLICANT_ASSESSMENT_DETAILS]: (
    state: RecruiterState
  ): ApplicantAssessmentDetailsResponse | null =>
    state.applicant_assessment_details
};
